/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import { Fun } from 'widgets-for-react'
import { TextImageBlockStyle } from '../../cms/blocks/widgets/textImageBlock.gen'
import { TextBlockStyle } from '../../cms/blocks/widgets/textBlock.gen'
import { TextReadMoreBlockStyle } from '../../cms/blocks/widgets/textReadMoreBlock.gen'
import { CtaBlockStyle } from '../../cms/blocks/widgets/ctaBlock.gen'
import { LinkBlockStyle } from '../../cms/blocks/widgets/linkBlock.gen'
import { DownloadBlockStyle } from '../../cms/blocks/widgets/downloadBlock.gen'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { ExpandBlockStyle } from '../../cms/blocks/widgets/expandBlock.gen'
import { MediaBlockStyle } from '../../cms/blocks/widgets/mediaBlock.gen'
import { QuoteBlockStyle } from '../../cms/blocks/widgets/quoteBlock.gen'
import { IframeBlockStyle } from '../../cms/blocks/widgets/iframeBlock.gen'
import { ImageGalleryBlockStyle } from '../../cms/blocks/widgets/imageGalleryBlock.gen'
import { QuoteBlockNestedStyle } from '../../cms/blocks/widgets/quoteBlockNested.gen'
import { MediaBlockNestedStyle } from '../../cms/blocks/widgets/mediaBlockNested.gen'
import { TextBlockNestedStyle } from '../../cms/blocks/widgets/textBlockNested.gen'
import { FormStyle } from '../utils/forms'
import { reportsBlockStyle } from './custom_blocks/widgets/reportsBlock.mod'
import { GridHighlightBlockStyle } from './custom_blocks/widgets/gridHighlightBlock'
import { factsAndFiguresBlockStyle } from './custom_blocks/widgets/factsAndFiguresBlock.mod'
import { customSpacerBlockStyle } from './custom_blocks/widgets/customSpacerBlock.mod'
// import { featuredContentBlockStyle } from './custom_blocks/widgets/featuredContentBlock.mod'
import { quotesBlockStyle } from './custom_blocks/widgets/quotesBlock.mod'
import { latestUpdatesBlockStyle } from './custom_blocks/widgets/latestUpdatesBlock.mod'

export const textImageClasses: Fun<'left' | 'right', TextImageBlockStyle> = (imageDirection) => ({
  block_contentwidth_classname: `block block--featured-content featured-content--image_left`,
  inner_classname: 'block__inner ',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content container container--s grid--block',
  text_classname: 'block__text',
  visual_classname: 'block__visual',
  image_classname: 'block__image lazyload',
  footer_classname: 'block__clickables',
  clickable_wrapper_classname: 'block__clickable',
  clickable_primary_classname: 'button button--primary--inverted',
  clickable_secondary_classname: 'link'
})

export const textBlockClasses: TextBlockStyle = {
  block_classname: 'block block--text',
  inner_classname: 'block__inner container container--s grid--block',
  content_classname: 'block__content',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  text_classname: 'block__text text--styled text--spacing',
  footer_classname: 'block__clickables',
  clickable_wrapper_classname: 'block__clickable',
  clickable_primary_classname: 'button button--primary',
  clickable_secondary_classname: 'link link--primary'
}

export const gridHighlightBlockClasses: GridHighlightBlockStyle = {
  block_classname: 'block block--linkgrid block--highlight block--color spacing--m inview',
  inner_classname: 'block__inner grid--spacing',
  content_classname: 'block__content container container--m grid--gutter',
  list_classname: 'block__list grid',
  grid_item_classname: 'grid__item',
  grid_article_classname: 'grid__article',
  grid_link_classname: 'grid__link',
  grid_content_classname: 'grid__content',
  grid_header_classname: 'grid__header',
  grid_label_classname: 'grid__label block__label',
  grid_title_classname: 'grid__title title--xs',
  grid_intro_classname: 'grid__intro text--spacing',
  grid_fauxlink_classname: 'grid__fauxlink link link--arrow',

}

export const textBlockNestedClasses: TextBlockNestedStyle = {
  block_classname: 'block block--text-nested',
  text_classname: 'block__text text--styled text--spacing'
}

export const ctaBlockClasses: Fun<boolean, CtaBlockStyle> = (hasImage) => ({
  block_contentwidth_classname: `block block--cta ${hasImage ? 'cta--image' : 'cta--text'
    }`,
  block_fullwidth_classname: `block block--cta ${hasImage ? 'cta--image' : 'cta--text'
    }`,
  inner_classname: 'block__inner ',
  header_classname: 'block__header',
  title_classname: 'block__title title--l',
  intro_classname: 'block__intro',
  content_classname: 'block__content container container--s grid--block',
  text_classname: 'block__text',
  visual_classname: 'block__visual',
  image_classname: 'block__image lazyload',
  footer_classname: 'block__clickables',
  clickable_wrapper_classname: 'block__clickable',
  clickable_primary_classname: 'button button--primary',
  clickable_secondary_classname: 'link'
})

export const quotesBlockClasses: Fun<boolean, quotesBlockStyle> = (hasImage) => ({
  block_classname: `block block--quote`,
  inner_classname: `block__inner container container--s grid--block`,
  content_classname: 'block__content',
  quote_classname: 'block__quote title--m',
  author_classname: 'block__author text--s',
  footer_classname: 'block__footer',
  clickable_classname: 'button button--primary',
  visual_classname: 'block__visual fit-object',
  image_classname: 'block__image lazyload'
})

export const latestUpdatesBlockClasses: Fun<boolean, latestUpdatesBlockStyle> = (hasImage) => ({
  block_classname: `block block--quote`,
  inner_classname: `block__inner container container--s grid--block`,
  content_classname: 'block__content',
  author_classname: 'block__author text--s',
  footer_classname: 'block__footer',
  clickable_classname: 'button button--primary',
  visual_classname: 'block__visual fit-object',
  image_classname: 'block__image lazyload'
})

// export const featuredContentBlockClasses: Fun<boolean, featuredContentBlockStyle> = (imageDirection) => ({
//   block_contentwidth_classname: `block block--featured-content featured-content--image_left`,
//   inner_classname: 'block__inner ',
//   header_classname: 'block__header',
//   title_classname: 'block__title title--m',
//   intro_classname: 'block__intro',
//   content_classname: 'block__content container container--s grid--block',
//   text_classname: 'block__text',
//   visual_classname: 'block__visual',
//   image_classname: 'block__image lazyload',
//   footer_classname: 'block__clickables',
//   clickable_wrapper_classname: 'block__clickable',
//   clickable_primary_classname: 'button button--primary--inverted',
//   clickable_secondary_classname: 'link'
// })

export const factsAndFiguresBlockClasses: Fun<boolean, factsAndFiguresBlockStyle> = (hasImage) => ({
  block_contentwidth_classname: 'block block--kpis',
  block_fullwidth_classname: 'block block--kpis block--full-width',
  inner_classname: 'block__inner ',
  header_classname: 'block__header',
  list_classname: 'block__list',
  item_classname: 'block__item',
  title_classname: 'block__title title--l',
  label_classname: 'block__label text--l',
  content_classname: 'block__content container container--m grid--block',
  text_classname: 'block__text',
  visual_classname: 'block__visual',
  image_classname: 'block__image lazyload',
  footer_classname: 'block__clickables',
  clickable_wrapper_classname: 'block__clickable',
  clickable_primary_classname: 'button button--primary--inverted',
  clickable_secondary_classname: 'link'
})

export const customSpacerBlockClasses: Fun<boolean, customSpacerBlockStyle> = (hasImage) => ({
  block_classname: 'block block--custom-spacer',
  inner_classname: 'block__inner ',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content container container--s grid--block',
  text_classname: 'block__text',
  visual_classname: 'block__visual',
  image_classname: 'block__image lazyload',
  footer_classname: 'block__clickables',
  clickable_wrapper_classname: 'block__clickable',
  clickable_primary_classname: 'button button--primary--inverted',
  clickable_secondary_classname: 'link'
})

export const textReadMoreBlockClasses: TextReadMoreBlockStyle = {}

export const linkListBlockClasses: LinkBlockStyle = {
  block_classname: 'block block--link block--lists',
  inner_classname: 'block__inner container container--m grid--block',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  list_classname: 'block__list blocklist',
  item_classname: 'block__item blocklist__item',
  link_classname: 'block__link blocklist__link',
  link_label_classname: 'blocklist__title title--xs',
  link_text_classname: 'blocklist__subtitle',
  link_icon_classname: 'blocklist__icon',
  icon_external_id: '#icon--box',
  icon_internal_id: '#icon--box'
}

export const downloadBlockClasses: DownloadBlockStyle = {
  block_classname: 'block block--download block--lists',
  inner_classname: 'block__inner container container--m grid--block',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  list_classname: 'block__list blocklist',
  item_classname: 'block__item blocklist__item',
  link_classname: 'block__link blocklist__link',
  link_label_classname: 'blocklist__title title--xs',
  link_text_classname: 'blocklist__subtitle',
  link_icon_classname: 'blocklist__icon',
  icon_file_id: '#icon--file',
  icon_pdf_id: '#icon--file',
  icon_excel_id: '#icon--file',
  icon_word_id: '#icon--file',
  icon_zip_id: '#icon--box'
}

export const linkGridBlockClasses: LinkGridBlockStyle = {
  block_classname: 'block block--linkgrid block--variant-rounded',
  inner_classname: 'block__inner grid--spacing',
  header_classname: 'block__header container container--s grid--gutter',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro text--spacing',
  content_classname: 'block__content container container--m grid--gutter',
  list_classname: 'block__list grid',
  grid_article_classname: 'grid__article',
  grid_item_classname: 'grid__item',
  grid_link_classname: 'grid__link',
  grid_content_classname: 'grid__content',
  grid_header_classname: 'grid__header',
  grid_label_classname: 'grid__label block__label',
  grid_title_classname: 'grid__title title--xs',
  grid_intro_classname: 'grid__intro text--spacing',
  grid_fauxlink_classname: 'grid__fauxlink link link--arrow',
  grid_visual_classname: 'grid__visual container fit-object',
  grid_image_classname: 'grid__image lazyload',
  footer_classname: 'block__footer grid--gutter',
  clickable_classname: 'button button--primary'
}

export const linkGridBlockPlainClasses: LinkGridBlockStyle = {
  block_classname: 'block block--linkgrid spacing--m',
  inner_classname: 'block__inner grid--spacing',
  header_classname: 'block__header container container--s grid--gutter',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro  text--spacing',
  content_classname: 'block__content container container--m grid--gutter',
  list_classname: 'block__list grid',
  grid_article_classname: 'grid__article',
  grid_item_classname: 'grid__item',
  grid_link_classname: 'grid__link',
  grid_content_classname: 'grid__content',
  grid_header_classname: 'grid__header',
  grid_label_classname: 'grid__label block__label',
  grid_title_classname: 'grid__title title--xs',
  grid_intro_classname: 'grid__intro text--spacing',
  grid_fauxlink_classname: 'grid__fauxlink link link--arrow',
  footer_classname: 'block__footer grid--gutter',
  clickable_classname: 'button button--primary'
}

export const expandBlockClasses: ExpandBlockStyle = {
  block_classname: 'block block--expand',
  inner_classname: 'block__inner container container--m grid--block',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  list_classname: 'block__list blocklist',
  expand_item_classname: 'block__item blocklist__item',
  expand_details_classname: 'block__details',
  expand_summary_classname: 'block__summary blocklist__link',
  expand_title_classname: 'blocklist__title title--xs',
  expand_subtitle_classname: 'blocklist__subtitle',
  expand_text_classname: 'block__text blocklist__content text--styled',
  expand_icon_classname: 'blocklist__icon',
  icon_open_id: '#icon--chevron',
  icon_closed_id: '#icon--chevron',
  footer_classname: 'block__footer',
  clickable_classname: 'button button--primary'
}

export const mediaBlockClasses: MediaBlockStyle = {
  block_classname: 'block block--media',
  inner_classname: 'block__inner container container--s grid--block',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  media_classname: 'block__media',
  figure_fullwidth_classname: 'media media--full',
  figure_contentwidth_classname: 'media media--content',
  figure_image_classname: 'media--image',
  figure_video_classname: 'media--video',
  video_classname: 'media__video',
  image_classname: 'media__image lazyload',
  figcaption_classname: 'block__figcaption media__figcaption',
  caption_classname: 'media__caption text--s',
  source_classname: 'block__source text--s',
  cookies_classname: 'cookies',
  cookies_inner_classname: 'cookies__inner gutter--m',
  cookies_text_classname: 'cookies__text text--styled',
  cookies_clickable_classname: 'cookies__clickable button button--primary'
}

export const mediaBlockNestedClasses: MediaBlockNestedStyle = {
  block_classname: 'block block--media-nested',
  media_classname: 'block__media',
  figure_image_classname: 'media--image',
  figure_video_classname: 'media--video',
  video_classname: 'media__video',
  image_classname: 'media__image lazyload',
  figcaption_classname: 'block__figcaption media__figcaption',
  caption_classname: 'media__caption text--s',
  source_classname: 'block__source text--s text--s',
  cookies_classname: 'cookies',
  cookies_inner_classname: 'cookies__inner gutter--m',
  cookies_text_classname: 'cookies__text text--styled',
  cookies_clickable_classname: 'cookies__clickable button button--primary'
}

export const quoteBlockClasses: Fun<boolean, QuoteBlockStyle> = (hasImage) => ({
  block_classname: `block block--quote`,
  inner_classname: `block__inner container container--s grid--block`,
  content_classname: 'block__content',
  quote_classname: 'block__quote title--m',
  author_classname: 'block__author text--s',
  footer_classname: 'block__footer',
  clickable_classname: 'button button--primary',
  visual_classname: 'block__visual fit-object',
  image_classname: 'block__image lazyload'
})

export const quoteBlockNestedClasses: QuoteBlockNestedStyle = {
  block_classname: 'block block--quote block--quote-nested quote--text',
  content_classname: 'block__content',
  quote_classname: 'block__quote',
  author_classname: 'block__author text--s'
}

export const iframeBlockClasses: IframeBlockStyle = {
  block_classname: 'block block--iframe spacing--m',
  inner_classname: 'block__inner container container--m gutter--2-1',
  content_classname: 'block__content',
  iframe_classname: 'block__iframe',
  cookies_classname: 'cookies',
  cookies_inner_classname: 'cookies__inner gutter--m',
  cookies_text_classname: 'cookies__text text--styled',
  cookies_clickable_classname: 'cookies__clickable button button--primary'
}

export const hubspotIframeBlockClasses: IframeBlockStyle = {
  block_classname: 'block block--iframe-hubspot spacing--m',
  inner_classname: 'block__inner container container--m gutter--2-3',
  content_classname: 'block__content',
  iframe_classname: 'block__iframe',
  cookies_classname: 'cookies',
  cookies_inner_classname: 'cookies__inner gutter--m',
  cookies_text_classname: 'cookies__text text--styled',
  cookies_clickable_classname: 'cookies__clickable button button--primary'
}

export const imageGalleryBlockClasses: ImageGalleryBlockStyle = {
  block_classname: 'block block--background block--gallery',
  inner_classname: 'block__inner container container--s grid--block',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  gallery_list_classname: 'block__list gallery',
  gallery_item_classname: 'gallery__item',
  gallery_button_classname: 'gallery__button',
  gallery_image_classname: 'gallery__image lazyload',
  gallery_toggle_classname: 'gallery__toggle title--l',
  lightbox_classname: 'lightbox',
  lightbox_inner_classname: 'lightbox__inner container gutter--m',
  lightbox_nav_classname: 'lightbox__nav',
  lightbox_nav_inner_classname: 'lightbox__nav-inner',
  lightbox_close_classname: 'lightbox__close',
  lightbox_figure_classname: 'lightbox__figure',
  lightbox_visual_classname: 'lightbox__visual container container--s',
  lightbox_image_classname: 'lightbox__image lazyload',
  lightbox_figcaption_classname: 'lightbox__figcaption block__figcaption',
  lightbox_caption_classname: 'lightbox__caption',
  lightbox_source_classname: 'lightbox__source block__source label--m',
  lightbox_controls_classname: 'lightbox__controls',
  lightbox_controls_inner_classname: 'lightbox__controls-inner',
  lightbox_next_classname: 'lightbox__control lightbox__control--next',
  lightbox_prev_classname: 'lightbox__control lightbox__control--previous',
  icon_close_id: '#icon--close-circled',
  icon_next_id: '#icon--arrow-rx',
  icon_previous_id: '#icon--arrow-lx'
}

export const formClasses: FormStyle = {
  block_classname: 'block block--form contact spacing--m container container--m gutter--2-3',
  inner_classname: 'block__inner',
  header_classname: 'block__header',
  title_classname: 'block__title title--m',
  content_classname: 'block__content',
  intro_classname: 'block__intro text--styled',
  subtitle_classname: 'block__subtitle title--s',
  text_classname: 'block__text text--styled',
  form_classname: 'block__form',
  footer_classname: 'block__clickables',
  clickable_wrapper_classname: 'block__clickable',
  clickable_primary_classname: 'button button--primary',
  clickable_secondary_classname: 'link'
}

export const reportClasses: reportsBlockStyle = {
  block_classname: 'block block--reports',
  inner_classname: 'block__inner container container--m grid--block',
  list_classname: 'tabs',
  list_item_classname: 'tabs__item tab title--xs',
  list_item_label_classname: 'tab__button',
  item_title_classname: 'tab-item__label',
  clickable_classname: 'tab-item__button',
  table_row_classname: 'report__row',
  table_head_classname: 'report__head',
}